import { Button } from "antd";
import { useHistory } from "react-router-dom";
import { Locale } from "../../../utils";

const i18n = Locale.getInstance();

const VideoCategoryListHeader = ({ selectCategory }) => {
  const history = useHistory();

  return (
    <div className="header">
      <div className="actions">
        <Button
          type="default"
          onClick={() => history.push("/main/videos")}
          style={{ marginRight: 8 }}
        >
          {i18n.t("video.title")}
        </Button>
        <Button
          onClick={() => {
            selectCategory();
          }}
          type="primary"
        >
          {i18n.t("video.category.add")}
        </Button>
      </div>
    </div>
  );
};

export default VideoCategoryListHeader;
